export const BEGIN_FETCHING_PAGE_DATA = "BEGIN_FETCHING_PAGE_DATA";
export const COMPLETE_FETCHING_PAGE_DATA = "COMPLETE_FETCHING_PAGE_DATA";
export const ADD_PAGE_DATA = "ADD_PAGE_DATA";
export const COMPLETE_CACHED_PAGE_LOAD = "COMPLETE_CACHED_PAGE_LOAD";
export const SET_CORRELATION_ID = "SET_CORRELATION_ID";
export const SET_CURRENT_PRODUCT = "SET_CURRENT_PRODUCT";
export const SET_CURRENT_STORY = "SET_CURRENT_STORY";
export const ANALYTICS_DATA_LAYER_LOADED = "ANALYTICS_DATA_LAYER_LOADED";
export const ADD_CDP_PAGE_DATA = "ADD_CDP_PAGE_DATA";
export const ADD_CDP_PAGE_PRODUCTS = "ADD_CDP_PAGE_PRODUCTS";

export function setCorrelationId(correlationId) {
  return function (dispatch) {
    dispatch({
      type: SET_CORRELATION_ID,
      correlationId,
    });
  };
}

export function setCurrentStoryContainer(container) {
  return function (dispatch) {
    dispatch({
      type: SET_CURRENT_STORY,
      container,
    });
  };
}

export function beginPageDataFetch(path) {
  return function (dispatch) {
    dispatch({
      type: BEGIN_FETCHING_PAGE_DATA,
      path,
    });
  };
}

export function addPageData(path, data, timestamp = Date.now()) {
  return function (dispatch) {
    if (typeof data === "object") {
      data.timestamp = timestamp;
    }
    dispatch({
      type: ADD_PAGE_DATA,
      path,
      data,
    });
  };
}

export function addCDPPageProducts(path, data, timestamp = Date.now()) {
  return function (dispatch) {
    if (typeof data === "object") {
      data.timestamp = timestamp;
    }
    dispatch({
      type: ADD_CDP_PAGE_PRODUCTS,
      path,
      data,
    });
  };
}

export function addCDPPageData(path, data, timestamp = Date.now()) {
  return function (dispatch) {
    if (typeof data === "object") {
      data.cdpData.timestamp = timestamp;
    }
    dispatch({
      type: ADD_CDP_PAGE_DATA,
      path,
      data,
    });
  };
}

export function completePageDataFetch(path, isLazyLoad) {
  let disableAnalyticsPageLoad;
  if (isLazyLoad) {
    disableAnalyticsPageLoad = true;
  }
  return function (dispatch) {
    dispatch({
      type: COMPLETE_FETCHING_PAGE_DATA,
      path,
      disableAnalyticsPageLoad,
    });
  };
}

export function completeCachedPageLoad(path, pageParams) {
  return function (dispatch) {
    dispatch({
      type: COMPLETE_CACHED_PAGE_LOAD,
      path,
    });
  };
}

export function analyticsDataLayerLoaded(digitalData) {
  return {
    type: ANALYTICS_DATA_LAYER_LOADED,
    digitalData,
  };
}
